<template>
    <a-row type="flex" :gutter="[20,20]" class="menu-row">
        <a-col class="menu-row-tree">
            <menu-tree/>
        </a-col>
        <a-col class="menu-row-content">
            <MenuInfo/>
            <MenuList/>
        </a-col>
    </a-row>
</template>

<script>
import MenuTree from "@/views/sys/menu/components/MenuTree";
import MenuInfo from "@/views/sys/menu/components/MenuInfo";
import MenuList from "@/views/sys/menu/components/MenuList";

export default {
    name: "index",
    components: {MenuList, MenuInfo, MenuTree}
}
</script>

<style scoped lang="less">
.menu-row {
    height: 100%;
    overflow: hidden;
}

.menu-row-tree {
    width: 350px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
}

.menu-row-content {
    flex: 1;
    min-width: 1px;
    min-height: 1px;
    height: 100%;
    overflow: hidden auto;
}
</style>
